/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsViewerAliases {
  ACTION_END_TREATMENT = 'action-end-treatment',
  ACTION_INACTIVATE_WOUND = 'action-inactivate-wound',
  ACTION_NEW_WOUND = 'action-new-wound',
  ACTION_UNDO_END_TREATMENT = 'action-undo-end-treatment',
  CHECKBOX_ALLERGY_MEDICATIONS = 'checkbox-allergyMedications',
  CHECKBOX_INDETERMINATE_START = 'checkbox-indeterminateStart',
  CHECKBOX_PRESENCE_PAIN = 'checkbox-presencePain',
  CHECKBOX_WOUND_HISTORY = 'checkbox-woundHistory',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_ADMITTED_INJURED = 'field-admittedInjured',
  FIELD_ALLERGIES = 'field-allergies',
  FIELD_ALLERGY_MEDICATIONS = 'field-allergyMedications',
  FIELD_CLINIC = 'field-clinic',
  FIELD_DIAGNOSIS = 'field-diagnosis',
  FIELD_INDETERMINATE_START = 'field-indeterminateStart',
  FIELD_MEDICAL = 'field-medical',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PAIN_SITE = 'field-pain-site',
  FIELD_PRESENCE_PAIN = 'field-presencePain',
  FIELD_REASON_END_TREATMENT = 'field-reason-end-treatment',
  FIELD_RELEASE_DATE = 'field-release-date',
  FIELD_RELEASE_USER = 'field-release-user',
  FIELD_SEQUENCE_IDENTIFICATION = 'field-sequenceIdentification',
  FIELD_SEQUENCE_LOCATION = 'field-sequenceLocation',
  FIELD_SEQUENCE_WOUND_CLASSIF = 'field-sequenceWoundClassif',
  FIELD_SEQUENCE_WOUND_TYPE = 'field-sequenceWoundType',
  FIELD_SERVICE_SECTOR = 'field-serviceSector',
  FIELD_START_DATE_WOUND = 'field-startDateWound',
  FIELD_WHAT_USED = 'field-whatUsed',
  FIELD_WHO_TREATED = 'field-whoTreated ',
  FIELD_WOUND_DAY = 'field-woundDay',
  FIELD_WOUND_FORMAT = 'field-woundFormat',
  FIELD_WOUND_HISTORY = 'field-woundHistory',
  FIELD_WOUND_MONTH = 'field-woundMonth',
  FIELD_WOUND_YEAR = 'field-woundYear',
  FORM_WOUNDS_VIEWER = 'form-wounds-viewer',
  LAYOUT_WOUNDS_VIEWER = 'layout-wounds-viewer',
  RADIO_GROUP_ADMITTED_INJURED = 'radio-group-admittedInjured',
  TEXT_ALLERGIES = 'text-allergies',
  TEXT_CLINIC = 'text-clinic',
  TEXT_DIAGNOSIS = 'text-diagnosis',
  TEXT_MEDICAL = 'text-medical',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PAIN_SITE = 'text-pain-site',
  TEXT_REASON_END_TREATMENT = 'text-reason-end-treatment',
  TEXT_RELEASE_DATE = 'text-release-date',
  TEXT_RELEASE_USER = 'text-release-user',
  TEXT_SEQUENCE_IDENTIFICATION = 'text-sequenceIdentification',
  TEXT_SEQUENCE_LOCATION = 'text-sequenceLocation',
  TEXT_SEQUENCE_WOUND_CLASSIF = 'text-sequenceWoundClassif',
  TEXT_SEQUENCE_WOUND_TYPE = 'text-sequenceWoundType',
  TEXT_SERVICE_SECTOR = 'text-serviceSector',
  TEXT_START_DATE = 'text-start-date',
  TEXT_WHAT_USED = 'text-whatUsed',
  TEXT_WHO_TREATED = 'text-whoTreated ',
  TEXT_WOUND_DAY = 'text--woundDay',
  TEXT_WOUND_FORMAT = 'text-woundFormat',
  TEXT_WOUND_MONTH = 'text-woundMonth',
  TEXT_WOUND_YEAR = 'text-woundYear',
}
export { WoundsViewerAliases };
